import http from "plugins/axios";

export default {
  getSymbols() {
    return http.get({
      url: "/la/admin/symbol/findAll",
      data: {
        buyCoin: "",
        page: 1,
        size: 10000,
        symbol: "",
        state: "",
      },
    });
  },
  getKline({ symbolId, time }) {
    return http.get({
      url: "/la/admin/inner/kline/spot/get",
      data: { symbolId, time },
    });
  },
  repairKline(data) {
    return http.post({
      url: "/la/admin/inner/kline/spot/repair",
      data,
    });
  },
  getRepairStatus(repairId) {
    return http.get({
      url: "/la/admin/inner/kline/spot/repair/status",
      data: { repairId },
    });
  },
};
